import React from 'react'

const Cart = ({ fill = '#1B1B1A' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_2594_133748)">
        <path
          d="M10.3667 8.66683C10.8667 8.66683 11.3067 8.3935 11.5334 7.98016L13.9201 3.6535C14.1667 3.2135 13.8467 2.66683 13.3401 2.66683H3.47341L2.84675 1.3335H0.666748V2.66683H2.00008L4.40008 7.72683L3.50008 9.3535C3.01341 10.2468 3.65341 11.3335 4.66675 11.3335H12.6667V10.0002H4.66675L5.40008 8.66683H10.3667ZM4.10675 4.00016H12.2067L10.3667 7.3335H5.68675L4.10675 4.00016ZM4.66675 12.0002C3.93341 12.0002 3.34008 12.6002 3.34008 13.3335C3.34008 14.0668 3.93341 14.6668 4.66675 14.6668C5.40008 14.6668 6.00008 14.0668 6.00008 13.3335C6.00008 12.6002 5.40008 12.0002 4.66675 12.0002ZM11.3334 12.0002C10.6001 12.0002 10.0067 12.6002 10.0067 13.3335C10.0067 14.0668 10.6001 14.6668 11.3334 14.6668C12.0667 14.6668 12.6667 14.0668 12.6667 13.3335C12.6667 12.6002 12.0667 12.0002 11.3334 12.0002Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2594_133748">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Cart
